/**
 * Behind the world: indoors, the room's floor in the dark; outdoors, the sky and distant mountains
 * (sliding a little with the camera for depth), then the painted ground.
 */
import { clamp } from '@nine/shared';
import { settings } from '../../settings';
import { paintSkyDiorama as paintSky } from '../skyDiorama';
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'interiorFloor',
  layer: 'ground',
  order: 100,
  draw(f) {
    if (f.scene) f.indoor.drawFloor(f.g, f.scene, f.ox, f.oy, f.W, f.H);
  },
});

registerRenderPass({
  id: 'sky',
  layer: 'ground',
  order: 110,
  state: () => ({ sky: null as HTMLCanvasElement | null }),
  draw(f, s) {
    if (!f.outdoors) return;
    // The sky is sized for the widest zoom and centred on the camera, so it zooms with the world
    // and does not jump when the render step changes. Rebuilt when the screen size changes.
    const room = f.room;
    const W = room.w + 130;
    const H = room.h;
    if (!s.sky || s.sky.width !== W || s.sky.height !== H) s.sky = paintSky(W, H);
    f.g.drawImage(s.sky, room.x - Math.round(clamp(f.cam.x * 0.05, 0, 120)), room.y);
  },
});

registerRenderPass({
  id: 'ground',
  layer: 'ground',
  order: 120,
  draw(f) {
    f.outdoors?.ground.draw(f.g, f.ox, f.oy, f.W, f.H);
  },
});

registerRenderPass({
  id: 'groundAmbience',
  layer: 'ground',
  order: 130,
  draw(f) {
    if (!f.outdoors || !settings.ambience) return;
    const { ground } = f.outdoors;
    ground.drawGlints(f.g, f.ox, f.oy, f.W, f.H, f.world.time);
    ground.drawAmbience(f.g, f.ox, f.oy, f.W, f.H, f.world.time);
  },
});
